// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"166":"1f5088b0","186":"98d5559c","187":"af238941","798":"525fb2c4","804":"ce2b3c4b","830":"467eeac8"}[chunkId] + ".css";
};